<ng-container *transloco="let t">
  <div class="workplace-selector">
    <div class="dropdown" ngbDropdown placement="bottom" container="body">
      <button class="workplace-selector__button" type="button" ngbDropdownToggle [disabled]="isLoading" aria-expanded="false">
        <i
          class="material-symbols-rounded"
          [class.filled]="currentKindergarten.isPrimary"
          [class.text-primary]="currentKindergarten.isPrimary"
        >
          other_houses
        </i>
        <span class="workplace-name"
          ><div class="name">{{ currentKindergarten.name }}</div>
          <div class="primary-workplace" *ngIf="currentKindergarten.isPrimary">{{ t('header/primaryWorkplace') }}</div></span
        >
        <div class="dropdown-icon mobile-hidden">
          <i class="material-symbols-rounded carret">keyboard_arrow_down</i>
        </div>
      </button>

      <div class="dropdown-menu" ngbDropdownMenu>
        <ng-container *ngIf="isLoading">
          <div class="dropdown-item-text text-center">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngFor="let kindergarten of kindergartens$ | async; trackBy: trackByKindergartenId">
          <button
            class="dropdown-item workplace-selector__item"
            [class.selected]="kindergarten.uuid === selectedKindergartenUUID"
            type="button"
            (click)="onKindergartenSelect(kindergarten)"
          >
            <div class="d-flex align-items-center">
              <i
                class="material-symbols-rounded me-2"
                [class.filled]="kindergarten.isPrimary"
                [class.text-primary]="kindergarten.isPrimary"
              >
                other_houses
              </i>
              <div class="flex-grow-1">
                <div class="workplace-name">
                  <div>{{ kindergarten.name }}</div>
                  <div class="primary-workplace" *ngIf="kindergarten.isPrimary">{{ t('header/primaryWorkplace') }}</div>
                </div>
              </div>
            </div>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
